var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),_c('Modals'),_vm._v(" "),_c('IncompleteViewingMsg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }